/** 前端应用公共headers 9920
 * sign: 取得方法，需要用到 请求对象data，develop预设值，time时间戳
 * 1.params: 获得需要提交的data对象
 * 2.对象按字典顺序排序并生成字串
 * 3.对生成字串进行sha1加密，并转成大写
 * 4.全大写字串：拼装上developer和time，后进行md5加密
 * 5.生成的md5值与/、develop、time、test拼接成sign值
 */
import QS from 'qs'
import {ksort} from './ksort.js'
import md5 from 'md5'
import sha1 from 'sha1'
/* 原写法
function encryption (objData) {
  // 后端定义的密钥
  let developer = '22307e52eb1895b809031eba30900f80'
  // 获得时间戳
  let time = Math.round(new Date().getTime() / 1000)
  // sha1加密并转大写
  let signSha1 = sha1(QS.stringify(ksort(objData)) + developer).toUpperCase()
  // md5加密并拼接输出
  let signMd5 = md5(developer + signSha1 + time)
  let sign = signMd5 + '/' + developer + '/' + time + '/test'
  return sign
}
export {
  encryption
}
*/
// 含用户登录写法，token和UID同时存在，如果不存在则按原格式输出 20190925
function encryption (objData, tokenData = '', uidData = '') {
  // 后端定义的密钥
  let developer = '22307e52eb1895b809031eba30900f80'
  // 如果有token值的时候执行
  if (tokenData !== '') {
    developer = tokenData
  }
  // 获得时间戳
  let time = Math.round(new Date().getTime() / 1000)
  // sha1加密并转大写
  let signSha1 = sha1(QS.stringify(ksort(objData)) + developer).toUpperCase()
  // md5加密并拼接输出
  let signMd5 = md5(developer + signSha1 + time)
  let sign = signMd5 + '/' + developer + '/' + time + '/m'
  // 如果登录信息都存在的时候替换原格式
  if (uidData !== '' && tokenData !== '') {
    sign = signMd5 + '/' + developer + '/' + uidData + '/' + time + '/m'
  }
  return sign
}
export {
  encryption
}



// WEBPACK FOOTER //
// ./src/assets/js/encryption.js